module.exports = __webpack_public_path__ + "static/img/invite-login.e7dc1e9f.png";